<template>
    <div class="container" ref='container'>
        <div class="header">
            <!-- <div> -->
            <div class="name">{{ langObj.hello }}</div>
            <div class="headerRight">
                <div class="todayClick" @click="toToday">{{ langObj.today }}</div>

            </div>

        </div>
        <div class="calendarMonth">
            <div style="display: flex">
                <div class="dropdown" @click="openMonth">
                    <div style="display: flex; margin-bottom: 8px;margin-right: 5px;">
                        <input readonly v-model="selected" class="dropdown-button" />
                        <div class="down-arrow2">
                        </div>
                    </div>
                    <div v-show="isOpenMonth" class="dropdown-menu" id="monthsBox">
                        <button :class="{ active: selected == item.name }" v-for="item in monthName" :key="item.id"
                            @click="selectMonth(item)" :value="item.id">
                            {{ item.name }}
                        </button>
                    </div>
                </div>
                <div class="dropdown" @click="openYear">
                    <div style="display: flex; margin-bottom: 8px;margin-right: 5px; width: 50%">
                        <input readonly v-model="selectedYear" class="dropdown-button" />
                        <div class="down-arrow2">
                        </div>
                    </div>
                    <div v-show="isOpenYear" class="dropdown-menu" id="yearsBox">
                        <button :class="{ active: Number(selectedYear) == Number(year) }" v-for="year in years"
                            :key="year" :value="year" @click="selectYear(year)">
                            {{ year }}
                        </button>
                    </div>
                </div>
            </div>
            <div class="item" v-for="(item, index) in weeksRow" :key="item"
                :class="{ weekend: index == 0 || index == 6 }">
                <span>{{ item.name }}</span>
            </div>
            <div class="item" v-for="item in firstDateDay" :key="item"></div>
            <!-- 显示当前的一月 -->
            <div class="item" @click="itemClick(item)" :class="{ weekend: weekendDays.includes(Number(item)) }"
                v-for="item in days" :key="item">
                <div
                    :class="{ today: realDate.year == nowYear && realDate.month == nowMonth && realDate.date == item, selected: selectedDate == item, holidayDate: holidayDates.includes(Number(item)) }">
                    {{ item }}</div>
            </div>
        </div>


        <banner1></banner1>
        <!-- 每日一言 -->
        <div class="props">
            <!-- 日程列表 -->
            <div style="margin-bottom:30px" v-show="isShow">
                <div style="display:flex;justify-content: space-between;">
                    <p style="margin: 6px 10px 10px 0px;font-weight:bolder">{{ langObj.schedule }}</p>
                    <div @click="addSchedule()" v-show="isShowSchedule" class="addSchedule">
                        <div class="addWrap">
                            <van-icon class="icon" name="plus" />
                        </div>
                    </div>
                </div>

                <div v-if="scheduleList.length > 0">
                    <div v-for="(item, index) in scheduleList" :key="index">
                        <div class="scheduleItem" @click='addSchedule(item)'>
                            <div class="wrap" :data-flag="item.flag">
                                <div class="icon" :data-flag="item.flag">
                                    <div class="img" :data-flag="item.flag"></div>
                                </div>
                                <div class="text" :data-flag="item.flag">
                                    <p :class="{ endStyle: item.flag == 'end', 'title': true }">
                                        <span style="font-weight: 700;">{{ item.title }}</span>
                                    </p>
                                    <p class="time">
                                        <span>{{
                formatTimeRange(convertCurrentTimeZone(item.startTime, item),
                    convertCurrentTimeZone(item.endTime, item))
            }}</span>
                                        <span :data-flag="item.flag" class='flag'><span v-show="item.flag == 'progress'"
                                                class="dot"></span>{{ item.flag == 'progress' ? langObj.progress :
                item.flag
                    == 'noStart' ? langObj.noStart : langObj.end }}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else v-show="isShowSchedule">
                    <div class="noSchedule">
                        <div class="wrap">
                            <van-icon @click="addSchedule()" name="plus" class="plusIcon" />
                        </div>
                        <p class="desc">{{ langObj.noSchedule }}</p>
                    </div>
                </div>
            </div>
            <div style="display: flex; justify-content: space-between">
                <div style="display: flex; justify-content: space-around">
                    <div class="day">
                        {{ parseInt(selectedDate) < 10 && !(/^0\d?$/.test(selectedDate)) ? "0" + selectedDate :
                selectedDate }} </div>
                            <div class="year">
                                <p>{{ getWeek(selectedWeek) }}</p>
                                <p>{{ getMonth(selectedMonth) }} {{ selectedYear }}</p>
                            </div>
                    </div>
                    <div class="star">
                        <img style="width: 17px; height: 17px; vertical-align: text-top; margin-right: 5px"
                            :src="getAssetsFile(customColor + star.img)" alt="" />
                        <span style="font-weight: bolder" v-if="star.name?.includes('1') || star.name?.includes('2')">{{
                star.name.slice(0, -1) }}</span>
                        <span style="font-weight: bolder" v-else>{{ star.name }}</span>
                    </div>
                </div>
                <div class="quotation"
                    v-if="isShow && langObj.lang != 'ru' && langObj.lang != 'br' && langObj.lang != 'tr' && langObj.lang != 'fr' && langObj.lang != 'de'">
                    <div class="bg">
                        <p style="font-size: 18px;font-weight: bolder; margin-bottom: 5px; padding-top: 20px">
                            {{ langObj.dayword }}</p>
                        <div style='max-height: 100px;overflow-y:auto;'>
                            <p style="font-size:14px;line-height: 2;">{{ quotation.replace(/"/g, '') }}</p>
                        </div>
                    </div>
                </div>

                <div class="holiday" v-show="selectedYear == realDate.year || selectedYear == realDate.year + 1">
                    <p style="margin: 30px 10px 10px 0px;font-weight:bolder">{{ langObj.holiday }}</p>
                    <p class='holidaySub' style="margin: -9px 10px 16px 0px; font-size: 12px;">{{ langObj.holidaySub }}
                    </p>
                    <ul>
                        <li class="item" v-if="Object.keys(currentHoliday).length != 0">
                            <p class="name" style='width:70%'> {{ currentHoliday.name }}</p>
                            <div class="days">
                                <span style="font-size: 12px">{{ langObj.today }}</span>
                            </div>
                        </li>
                        <li v-for="(holiday, index) in nearestHolidays" :key="index" class="item">
                            <p class="name" style='width:70%'>{{ holiday.nextHoliday }}</p>
                            <div class="days">
                                <span
                                    style="font-size: 24px;font-weight: bolder;width:48px;display:inline-block;text-align: center;">{{
                holiday.minDistance >= 10 ? holiday.minDistance : "0" + holiday.minDistance
            }}</span>
                                <span style="font-size: 12px;width:23px;display: inline-block">{{
                    holiday.minDistance == 1 ? langObj.day : langObj.days }}</span>
                            </div>
                        </li>
                    </ul>
                </div>

            </div>
            <!-- 添加日程 -->
            <van-popup class="addBg" v-model:show="scheduleAddModel" position="bottom" :style="{ height: '90%' }">
                <div id='scheduleWrap'>
                    <div>
                        <div class="addBgOpera" v-if='schedule.id'
                            style="display: flex;justify-content: space-between;align-items: center;">
                            <img @click='scheduleAddModel = false' style="width: 17px; height: 17px;padding:14px"
                                :src="getAssetsFile('closeIcon.png')" alt="" />
                            <van-icon class="successIcon" name="success"
                                style="margin-top:10px;font-size:26px;margin:14px" @click="editSchedule" />
                        </div>
                        <div class="addBgOpera" v-else
                            style="display: flex;justify-content: space-between;align-items: center">
                            <img @click='scheduleAddModel = false' style="width: 17px; height: 17px;padding:14px"
                                :src="getAssetsFile('closeIcon.png')" alt="" />
                            <van-icon class="successIcon" name="success"
                                style="margin-top:10px;font-size:26px;margin:14px" @click="createSchedule" />
                        </div>
                    </div>
                    <p class="addBgTitle" style="padding:0px 16px 20px;font-size:22px;">
                        {{ schedule.id ? langObj.editSchedule : langObj.creatSchedule }}
                    </p>
                    <van-cell-group inset>
                        <van-field class="textareavant" required v-model="schedule.title" rows="2" autosize
                            :label="langObj.scheduleTitile" type="textarea" maxlength="100" show-word-limit />
                    </van-cell-group>
                    <van-cell class="cellFiled" :title="langObj.scheduleStarttime" is-link @click="selDate"
                        :value="formatDate(currentDate)" />
                    <van-popup class="addBg" v-model:show="showBottom" closeable position="bottom"
                        :style="{ height: '55%' }">
                        <van-datetime-picker confirm-button-text=" " cancel-button-text=" " v-model="currentDate"
                            type="datetime" :min-date="minDate" :max-date="maxDate" />
                    </van-popup>
                    <van-cell class="cellFiled" :title="langObj.scheduleEndtime" is-link @click="selDateEnd"
                        :value="formatDate(currentDateEnd)" />
                    <van-popup class="addBg" v-model:show="showBottomEnd" closeable position="bottom"
                        :style="{ height: '55%' }">
                        <van-datetime-picker confirm-button-text=" " cancel-button-text=" " v-model="currentDateEnd"
                            type="datetime" :min-date="minDate" :max-date="maxDate" />
                    </van-popup>
                    <van-cell class="cellFiled" :value="alertTimeValue" is-link :title="langObj.scheduleRendertime"
                        @click="openAlertTime" />
                    <van-popup class="addBg" v-model:show="showAlertPicker" closeable destroy-on-close round
                        position="bottom">
                        <van-picker ref="pickerRef" :default-index="2" confirm-button-text=" " cancel-button-text=" "
                            :columns="columns" @change="onConfirmAlert" />
                    </van-popup>
                    <van-cell-group inset>
                        <van-field id="filedPlace" class="textareavant" v-model="schedule.place" rows="2" autosize
                            :label="langObj.schedulePlace" type="textarea" maxlength="50" show-word-limit />
                    </van-cell-group>
                    <van-cell-group inset>
                        <van-field id="filedDesc" class="textareavant" v-model="schedule.description" rows="2" autosize
                            :label="langObj.scheduleDesc" type="textarea" maxlength="50" show-word-limit />
                    </van-cell-group>
                    <div v-if='schedule.id' style="display: flex;justify-content: space-around;align-items: center;">
                        <van-button @click="delSchedule" class="delSchedule"><van-icon name="delete-o"
                                style="font-size:20px;margin-right:8px" />{{ langObj.delSchedule }}</van-button>
                    </div>
                </div>
            </van-popup>

        </div>
</template>
<script setup>
import { ref, computed, watch, onMounted, onUnmounted, nextTick, onBeforeMount, onBeforeUnmount } from "vue";
import dayjs from "dayjs";
import utc from "dayjs-plugin-utc";
import axios from "axios"
import { dateYinList, dateXiList, starList, festivalYinList, festivalYinListCurrent, festivalXiList, festivalRussianList, festivalEnList, festivalFrenchList, festivalItalyList, festivalPortugalList, festivalTurkishList, festivalGermanList, dateRussianList, dateFrenchList, dateItalyList, datePortugalList, dateTurkishList, dateGermanList, dateEnList } from "./source";
import { Field, CellGroup, Popup, Toast } from 'vant';
import { getLang } from "../lang.js"
import banner1 from "../adcomp/banner1.vue"

let langObj = ref({})
dayjs.extend(utc)
const intervalId = setInterval(() => {
    scheduleList.value.forEach(item => {
        item.flag = isWithinTimeRange(getCurrentTimeCompare(), convertCurrentTimeZone(item.startTime, item), convertCurrentTimeZone(item.endTime, item));
    })
    nextTick(() => {
        setColor(customColor.value)
    })
}, 1000 * 60);
// 日程
let scheduleAddModel = ref(false)
let scheduleAddTime = ref("")
const addSchedule = (item) => {
    setTimeout(() => {
        setColor(customColor.value)
    }, 100)
    if (isTimePassedOrBeyondYearEnd(scheduleAddTime.value)) {
        Toast.fail(langObj.value.disabledAdd);
        return
    }
    bubbleAddShow.value = false
    scheduleAddModel.value = true
    bubbleBackShow.value = true
    alertTimeValue.value = langObj.value.noRemind
    if (item) {
        schedule.value.id = item.id
        schedule.value.uuid = item.uuid
        schedule.value.title = item.title
        schedule.value.description = item.description
        schedule.value.startTime = item.startTime
        schedule.value.endTime = item.endTime
        schedule.value.place = item.place
        schedule.value.timezone = item.timezone
        schedule.value.region = item.region
        schedule.value.nextReminderTime = item.nextReminderTime
        currentDate.value = convertCurrentTimeZone(schedule.value.startTime, item)
        currentDateEnd.value = convertCurrentTimeZone(schedule.value.endTime, item)
        if (item.nextReminderTime != 0) {
            alertTime.value = item.nextReminderTime
            columns.value.forEach((item, index) => {
                if (item.value == alertTime.value) {
                    alertTimeValue.value = item.text
                    defalutIndex.value = index
                }
            })
        } else {
            alertTime.value = 0
            alertTimeValue.value = langObj.value.noRemind
        }
    } else {
        resetSchedule()
        alertTimeValue.value = langObj.value.noRemind
    }
}
const resetSchedule = () => {
    schedule.value = {
        id: "",
        uuid: '',
        startTime: "",
        endTime: "",
        title: "",
        description: "",
        place: "",
        nextReminderTime: "",
        // timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        timezone: new Date().getTimezoneOffset(),
        region: langObj.value.axiosLang
    }
    currentDate.value = getCurrentDate()
    currentDateEnd.value = getCurrentDateEnd()
}

let scheduleList = ref([])
const alertTime = ref(0)
const alertTimeValue = ref(langObj.value.noRemind)
const columns = ref([])
const defalutIndex = ref(0)
const pickerRef = ref(null);
const onConfirmAlert = (val, index) => {
    alertTime.value = val.value;
    alertTimeValue.value = val.text;
    defalutIndex.value = index
};
const openAlertTime = () => {
    showAlertPicker.value = true;
    if (schedule.value.id) {
        nextTick(() => {
            pickerRef.value.setIndexes([defalutIndex.value]); // 确保默认值生效
        });
    } else {
        nextTick(() => {
            pickerRef.value.setIndexes([0]); // 确保默认值生效
        });
    }

}

let schedule = ref({
    id: "",
    uuid: '',
    startTime: "",
    endTime: "",
    title: "",
    description: "",
    place: "",
    nextReminderTime: "",
    // timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    timezone: new Date().getTimezoneOffset(),
    region: langObj.value.axiosLang
})
let showBottom = ref(false);
let showBottomEnd = ref(false);
let bubbleAddShow = ref(true)
let bubbleBackShow = ref(false)
let showAlertPicker = ref(false)
const minDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), "00", "00")
const maxDate = new Date(new Date().getTime() + 365 * 24 * 60 * 60 * 1000)
maxDate.setHours(23, 59)
// 提交所有时间格式转化为零时区的时间戳
// time 格式 2025-02-26 14:28
const convertUtcTimeStamp = (time) => {
    const localTime = dayjs(time, "YYYY-MM-DD HH:mm"); // 默认是当前时区的时间

    // 转换为 UTC 时间
    const utcTime = localTime.utc().format("YYYY-MM-DD HH:mm");
    const utcTimestamp = new Date(utcTime).getTime()
    return utcTimestamp
}
// 零时区的时间戳转化为当前时区时间戳
const convertCurrentTimeZone = (utcTimestamp, item) => {
    // 创建一个 Date 对象，表示 UTC 时间
    const utcDate = new Date(utcTimestamp);
    // 获取使用者的时区偏移量（以分钟为单位）
    const offsetMinutes = Number(item.timezone); // 返回的是本地时区与 UTC 的偏移量（负值表示东时区）

    console.log(offsetMinutes, "offsetMinutes")
    // 手动计算使用者的本地时间
    let localTimestamp
    if (offsetMinutes < 0) { // 东时区 offsetMinutes值为负，时间快，所以要加上 负负得正
        localTimestamp = utcTimestamp - (offsetMinutes * 60 * 1000); // 调整时间戳
    } else { // 西时区
        localTimestamp = utcTimestamp + (offsetMinutes * 60 * 1000); // 调整时间戳
    }
    const localDate = new Date(localTimestamp);
    // 格式化输出为 YYYY-MM-DD HH:mm
    const year = localDate.getFullYear();
    const month = String(localDate.getMonth()).padStart(2, '0');
    const day = String(localDate.getDate()).padStart(2, '0');
    const hours = String(localDate.getHours()).padStart(2, '0');
    const minutes = String(localDate.getMinutes()).padStart(2, '0');

    const formattedLocalTime = `${year}-${month}-${day} ${hours}:${minutes}`;
    console.log("使用者的本地时间（格式化）:", formattedLocalTime);

    return new Date(year, month, day, hours, minutes)



}
const getCurrentDate = (searchFlag) => {
    // 获取当前日期和时间
    let now
    if (scheduleAddTime.value && !isDatePassed(dayjs(scheduleAddTime.value).format("YYYY-MM-DD"))) {
        now = new Date(scheduleAddTime.value)
    } else {
        now = new Date();
    }
    // 兼容查询过去时间的日程
    if (searchFlag) {
        scheduleAddTime.value ? now = new Date(scheduleAddTime.value) : now = new Date();
    }
    // 获取年、月、日
    const year = now.getFullYear(); // 获取年份
    const month = String(now.getMonth()).padStart(2, '0'); // 获取月份（+1 因为 getMonth() 返回 0-11）
    const day = String(now.getDate()).padStart(2, '0'); // 获取日期
    return new Date(year, month, day, '00', '00')
}
const getCurrentDateEnd = (searchFlag) => {
    let now
    // 新增时只能设置今天和未来的
    if (scheduleAddTime.value && !isDatePassed(dayjs(scheduleAddTime.value).format("YYYY-MM-DD"))) {
        now = new Date(scheduleAddTime.value)
    } else {
        now = new Date();
    }
    // 兼容查询过去时间的日程
    if (searchFlag) {
        scheduleAddTime.value ? now = new Date(scheduleAddTime.value) : now = new Date();
    }
    const year = now.getFullYear(); // 获取年份
    const month = String(now.getMonth()).padStart(2, '0'); // 获取月份（+1 因为 getMonth() 返回 0-11）
    const day = String(now.getDate()).padStart(2, '0'); // 获取日期
    return new Date(year, month, day, '23', '59')
}
const currentDate = ref(getCurrentDate());
const currentDateEnd = ref(getCurrentDateEnd());
const selDate = () => {
    showBottom.value = true
}
const selDateEnd = () => {
    showBottomEnd.value = true
}
function formatDate(date, flag) {
    const pad = (num) => String(num).padStart(2, '0'); // 补零函数
    const year = date.getFullYear(); // 年
    const month = pad(date.getMonth() + 1); // 月（从0开始，需要加1）
    const day = pad(date.getDate()); // 日
    const hours = pad(date.getHours()); // 小时
    const minutes = pad(date.getMinutes()); // 分钟
    // 兼容日程列表展示规则
    if (flag) {
        return { year, month, day, hours, minutes };
    }
    console.log(`${year}-${month}-${day} ${hours}:${minutes}`, "format")
    return `${year}-${month}-${day} ${hours}:${minutes}`;
}
// 日程列表展示规则
function formatTimeRange(start, end) {
    const startFormatted = formatDate(start, true);
    const endFormatted = formatDate(end, true);
    // 判断是否跨年
    if (startFormatted.year !== endFormatted.year) {
        return `${startFormatted.year}/${startFormatted.month}/${startFormatted.day}-${startFormatted.hours}:${startFormatted.minutes}-${endFormatted.year}/${endFormatted.month}/${endFormatted.day}-${endFormatted.hours}:${endFormatted.minutes}`;
    }
    // 判断是否跨天
    if (startFormatted.month !== endFormatted.month || startFormatted.day !== endFormatted.day) {
        return `${startFormatted.month}/${startFormatted.day}-${startFormatted.hours}:${startFormatted.minutes}-${endFormatted.month}/${endFormatted.day}-${endFormatted.hours}:${endFormatted.minutes}`;
    }
    // 同一天
    return `${startFormatted.hours}:${startFormatted.minutes}-${endFormatted.hours}:${endFormatted.minutes}`;
}

// 判断开始结束时间
const convertToDateTime = (date) => {
    // 将年月日和时分拼接成日期时间字符串，例如 "2025-02-28T00:00"
    const dateTimeString = formatDate(date)
    // 创建一个日期时间对象
    const dateTimeObj = new Date(dateTimeString);
    return dateTimeObj;
};

// 提醒时间赋值
const setReminderTime = () => {
    schedule.value.nextReminderTime = alertTime.value

}
function isTimePassedOrBeyondYearEnd(timeStr) {
    const time = new Date(timeStr);
    time.setHours(0, 0, 0, 0); // 设置时间为当天的00:00
    const now = new Date();
    now.setHours(0, 0, 0, 0); // 设置时间为当天的00:00

    // 计算365天之后的日期
    const yearLater = new Date(now.getTime() + 365 * 24 * 60 * 60 * 1000);
    yearLater.setHours(0, 0, 0, 0);
    if (time < now || time > yearLater) {
        return true; // 时间已经过去，或者超过了365天之后的日期
    } else {
        return false; // 时间未过去且未超过365天之后的日期
    }
}

const createSchedule = () => {
    schedule.value.startTime = convertUtcTimeStamp(formatDate(currentDate.value))
    schedule.value.endTime = convertUtcTimeStamp(formatDate(currentDateEnd.value))
    schedule.value.uuid = paramUUid
    setReminderTime()
    // 创建一个日期时间对象
    const startDateTimeObj = convertToDateTime(currentDate.value);
    const endDateTimeObj = convertToDateTime(currentDateEnd.value);
    if (startDateTimeObj > endDateTimeObj) {
        // schedule.value.startTime = convertUtcTimeStamp(formatDate(currentDateEnd.value))
        // schedule.value.endTime = convertUtcTimeStamp(formatDate(currentDate.value))
        Toast.fail(langObj.value.timeCompareToast);
        return
    } else {
        schedule.value.startTime = convertUtcTimeStamp(formatDate(currentDate.value))
        schedule.value.endTime = convertUtcTimeStamp(formatDate(currentDateEnd.value))
    }
    if (!schedule.value.title) {
        return
    }
    axios
        .post("https://xm-widget-api.8uti7.com/schedule/insert", schedule.value)
        .then((response) => {
            if (response.data && !response.data.flag) {
                if (response.data.msg && response.data.msg.startsWith('duplicate')) {
                    Toast.fail(langObj.value.duplicateToast);
                    return
                }
            }
            getScheduleList(paramUUid)
        })
        .catch((error) => {
            console.error("请求失败:", error);
        });
    scheduleAddModel.value = false
    bubbleAddShow.value = true
    bubbleBackShow.value = false
    resetSchedule()


}

const editSchedule = () => {
    // 创建一个日期时间对象
    const startDateTimeObj = convertToDateTime(currentDate.value);
    const endDateTimeObj = convertToDateTime(currentDateEnd.value);

    if (startDateTimeObj > endDateTimeObj) {
        Toast.fail(langObj.value.timeCompareToast);
        return
    } else {
        schedule.value.startTime = convertUtcTimeStamp(formatDate(currentDate.value))
        schedule.value.endTime = convertUtcTimeStamp(formatDate(currentDateEnd.value))
    }
    if (!schedule.value.title) {
        return
    }

    setReminderTime()
    axios
        .post("https://xm-widget-api.8uti7.com/schedule/update", schedule.value)
        .then((response) => {
            if (response.data && !response.data.flag) {
                if (response.data.msg && response.data.msg.startsWith('duplicate')) {
                    Toast.fail(langObj.value.duplicateToast);
                    return
                }
            }
            getScheduleList(paramUUid)
        })
        .catch((error) => {
            console.error("请求失败:", error);
        });
    scheduleAddModel.value = false
    bubbleAddShow.value = true
    bubbleBackShow.value = false
}
const delSchedule = () => {
    let data = {
        id: schedule.value.id,
        region: schedule.value.region,
        uuid: paramUUid
    }
    axios
        .post("https://xm-widget-api.8uti7.com/schedule/delete", data)
        .then((response) => {
            if (response.data && !response.data.result) {
                showFailToast(response.data.message);
                return
            }
            getScheduleList(paramUUid)
        })
        .catch((error) => {
            console.error("请求失败:", error);
        });
    scheduleAddModel.value = false
    bubbleAddShow.value = true
    bubbleBackShow.value = false
}
const getScheduleList = (uuid) => {
    let data = {
        uuid,
        region: langObj.value.axiosLang,
        startTime: convertUtcTimeStamp(formatDate((getCurrentDate(true)))),
        endTime: convertUtcTimeStamp(formatDate((getCurrentDateEnd(true))))
    }
    axios
        .post("https://xm-widget-api.8uti7.com/schedule/getList", data)
        .then((response) => {
            if (response.data && response.data.result) {
                scheduleList.value = response.data.result
                scheduleList.value.forEach(item => {
                    item.flag = isWithinTimeRange(getCurrentTimeCompare(), convertCurrentTimeZone(item.startTime, item), convertCurrentTimeZone(item.endTime, item));
                })

                scheduleList.value.sort(compareEvents);
            } else {
                scheduleList.value = []
            }
            nextTick(() => {
                setColor(customColor.value)
            })
        })
        .catch((error) => {
            console.error("请求失败:", error);
        });
}
// 定义状态优先级
const flagPriority = { progress: 1, noStart: 2, end: 3 };

// 定义比较函数
function compareEvents(a, b) {
    // 按状态优先级排序
    if (flagPriority[a.flag] !== flagPriority[b.flag]) {
        return flagPriority[a.flag] - flagPriority[b.flag];
    }

    // 时间重叠的显示两条日程，按创建时间正序
    if (a.startTime === b.startTime && a.endTime === b.endTime) {
        return a.createTime - b.createTime;
    }

    // 其他情况按开始时间正序，其次按结束时间正序，最后按创建时间正序
    if (a.startTime !== b.startTime) {
        return a.startTime - b.startTime;
    }
    if (a.endTime !== b.endTime) {
        return a.endTime - b.endTime;
    }
    return a.createTime - b.createTime;
}

// 获取当前时间并格式化为 yyyy-mm-dd hh:mm
function getCurrentTimeCompare() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // 月份从 0 开始，需要加 1
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}`;
}

// 将时间格式 yyyy-mm-dd hh:mm 转换为 Date 对象
function parseTime(timeString) {
    const [datePart, timePart] = timeString.split(' ');
    const [year, month, day] = datePart.split('-').map(Number);
    const [hours, minutes] = timePart.split(':').map(Number);
    return new Date(year, month - 1, day, hours, minutes); // 月份从 0 开始
}

// 判断当前时间是否在指定的时间范围内
function isWithinTimeRange(currentTime, startTime, endTime) {
    const now = parseTime(currentTime);
    const start = parseTime(formatDate(startTime));
    const end = parseTime(formatDate(endTime));
    if (now < start) {
        return "noStart";
    } else if (now >= start && now <= end) {
        return "progress";
    } else {
        return "end";
    }
}

const scrollToSelectedOption = (menuSelector, optionValue) => {
    nextTick(() => {
        const menu = document.querySelector(menuSelector);
        const selectedOptionElement = menu.querySelector(`button[value="${optionValue}"]`);
        if (menu && selectedOptionElement) {
            // 计算选中选项相对于菜单顶部的距离
            let topOffset = selectedOptionElement.offsetTop;
            menu.scrollTop = topOffset;
        }
    });
};

// 点击弹窗外部关闭弹窗的函数
function outsideClick(event) {
    if ((isOpenMonth.value || isOpenYear.value) && !Array.from(modalOverlay.value).some((el) => el.contains(event.target))) {
        isOpenMonth.value = false;
        isOpenYear.value = false;
    }
}

const modalOverlay = ref(null);
onUnmounted(() => {
    clearInterval(intervalId);
    document.body.removeEventListener("click", outsideClick);
});
// 获取assets静态资源
const getAssetsFile = (url) => {
    return `/img/${url}`
    // return new URL(`/img/${url}`, import.meta.url).href;
};
let isOpenYear = ref(false);
let isOpenMonth = ref(false);
let selected = ref("");
function openYear() {
    isOpenYear.value = !isOpenYear.value;
    if (isOpenYear.value) {
        isOpenMonth.value = false;
        scrollToSelectedOption("#yearsBox", selectedYear.value.toString());
    }
}
function openMonth($event) {
    isOpenMonth.value = !isOpenMonth.value;
    if (isOpenMonth.value) {
        isOpenYear.value = false;
        scrollToSelectedOption("#monthsBox", selectedMonth.value.toString());
    }
}

function getFormatDate() {
    return `${selectedYear.value}-${selectedMonth.value}-${selectedDate.value}`;
}
function selectYear(option) {
    selectedYear.value = option;
    let current = getFormatDate();
    selectedWeek.value = dayjs(current).day();
    nextTick(() => {
        setColor(customColor.value)
    })
}
function selectMonth(option) {
    selected.value = option.name;
    selectedMonth.value = option.id;
    let current = getFormatDate();
    selectedWeek.value = dayjs(current).day();
    isOpenMonth.value = false;
    nextTick(() => {
        setColor(customColor.value)
    })
}
let quotationList = ref({})
let festivalList = ref([])
let selDay = ''
let customColor = ref("blue")
let paramUUid
const container = ref(null)
onMounted(async () => {

    // 兼容小部件跳转携带的日期
    const params = new URLSearchParams(window.location.search);
    const paramDate = params.get('date');
    paramUUid = params.get('info') || "user001";
    const paramColor = params.get('color');
    const paramLang = params.get('lang');
    const paramCreateSchedule = params.get('createSchedule');
    const paramScrollTo = params.get('scrollTo');
    const today = dayjs().format("YYYY-MM-DD");
    if (paramDate) {
        selDay = paramDate
        selectedYear.value = new Date(selDay).getFullYear()
        selectedMonth.value = new Date(selDay).getMonth() + 1
        selectedWeek.value = new Date(selDay).getDay()
        selectedDate.value = new Date(selDay).getDate()
        scheduleAddTime.value = paramDate
    } else {
        selDay = today
    }
    // let countryArr = ['in_id', 'es_es', 'en_us', 'ru_ru', 'pt_br', 'es_us', 'en_gb', 'tr_tr', 'fr_fr', 'de_de']
    // if (paramLang && countryArr.includes(paramLang.toLowerCase())) {
    //     let str = ""
    //     if (paramLang.toLowerCase() == 'in_id') {
    //         str = 'id'
    //     } else if (paramLang.toLowerCase() == 'pt_br') {
    //         str = 'br'
    //     } else if (paramLang.toLowerCase() == 'es_us' || paramLang.toLowerCase() == 'en_gb') {
    //         str = paramLang.toLowerCase()
    //     } else {
    //         str = paramLang.slice(0, 2)
    //     }
    //     console.log(str)
    //     langObj.value = getLang(str)
    // } else {
    //     console.log(3434)
    //     langObj.value = getLang("en")
    // }
    langObj.value = getLang()
    // 样式 
    let colorArr = ['black', 'orange', 'blue']
    if (langObj.value && langObj.value.customColor && colorArr.includes(langObj.value.customColor)) {
        customColor.value = langObj.value.customColor
    } else if (paramColor && colorArr.includes(paramColor)) {
        customColor.value = paramColor
    } else {
        customColor.value = 'blue'
    }
    nextTick(() => {
        setColor(customColor.value)
    })
    weeksRow.value = langObj.value.weeksRow
    monthName.value = langObj.value.monthName
    columns.value = langObj.value.columns
    //  水平7天
    currentWeekDays.value = getWeekDates(selDay);
    // 星座
    star.value = getZodiac(selDay);
    // 节日
    if (langObj.value.lang == "id") {
        quotationList.value = dateYinList
        festivalList.value = festivalYinListCurrent
    } else if (langObj.value.lang == "es" || langObj.value.lang == "es_us") {
        quotationList.value = dateXiList
        festivalList.value = festivalXiList
    } else if (langObj.value.lang == "en" || langObj.value.lang == "en_gb") {
        quotationList.value = dateEnList
        festivalList.value = festivalEnList
    } else if (langObj.value.lang == "ru") {
        quotationList.value = dateRussianList
        festivalList.value = festivalRussianList
    } else if (langObj.value.lang == 'fr') {
        quotationList.value = dateFrenchList
        festivalList.value = festivalFrenchList
    } else if (langObj.value.lang == 'it') {
        quotationList.value = dateItalyList
        festivalList.value = festivalItalyList
    } else if (langObj.value.lang == 'br') {
        quotationList.value = datePortugalList
        festivalList.value = festivalPortugalList
    } else if (langObj.value.lang == 'tr') {
        quotationList.value = dateTurkishList
        festivalList.value = festivalTurkishList
    } else if (langObj.value.lang == 'de') {
        quotationList.value = dateGermanList
        festivalList.value = festivalGermanList
    }

    currentHoliday.value = getHolidayCurrent(selDay.slice(5, 10))
    nearestHolidays.value = getNextHolidayDistance(selDay, festivalList.value)
    //鸡汤
    quotation.value = getQuotation(selDay, quotationList.value);
    selected.value = getMonth(selectedMonth.value);

    getHolidayDates()
    // 为每个元素添加点击事件监听器
    document.body.addEventListener("click", outsideClick);
    modalOverlay.value = document.querySelectorAll(".dropdown-button, .down-arrow2");
    // 日程
    scheduleList.value = JSON.parse(localStorage.getItem('schedule')) || []
    getScheduleList(paramUUid)
    if (paramCreateSchedule && paramCreateSchedule == 'true') {
        addSchedule()
    }
    // window.location.reload()
    if (paramScrollTo && paramScrollTo == 'true') {
        nextTick(() => {
            window.scrollTo({
                top: 500,
                behavior: 'smooth'
            })

        })
    }


});
const setColor = (color) => {
    let hearderClass = document.querySelector('.header');
    let containerClass = document.querySelector('.container');
    let todayClickClass = document.querySelector('.todayClick');
    let starClass = document.querySelector('.star');
    let yearClass = document.querySelector('.year');
    let holidaySubClass = document.querySelector('.holidaySub');
    let quatationClass = document.querySelector('.quotation');
    let currentDate = document.querySelector('.props .day');
    // 获取页面中的第一个<ul>元素
    const ulElement = document.querySelector('ul');
    const liElements = ulElement.querySelectorAll('li');
    // model
    let modelClass = document.querySelector('.calendarMonth');
    let dropdownMenuClass = document.querySelector('.dropdown-menu');
    const buttonElements = document.querySelectorAll('button');
    // noschedule
    let noScheduleBg = document.querySelector('.noSchedule');
    let noScheduleIconBg = document.querySelector('.noSchedule .wrap');
    let noScheduleDescColor = document.querySelector('.noSchedule .desc');
    let noScheduleIconColor = document.querySelector('.noSchedule .wrap .plusIcon');
    let addScheduleIconBg = document.querySelector('.addSchedule .addWrap');
    let scheduleAddIcon = document.querySelector('.addSchedule .icon');
    let scheduleAddBg = document.querySelector('.addBg');
    let scheduleAddBgTitle = document.querySelector('.addBg .addBgTitle');
    let scheduleSuccessIcon = document.querySelector('.successIcon');
    let scheduledelIcon = document.querySelector('.delSchedule');
    let scheduleAddOpera = document.querySelector('.addBgOpera');
    if (color == 'black') {
        hearderClass.style.setProperty('--block-color', '#333331');
        containerClass.style.setProperty('--bg-color', '#1d1d1d');
        containerClass.style.setProperty('--bg-textColor', '#fff');
        todayClickClass.style.setProperty('--theme-color', '#ffdd39');
        todayClickClass.style.setProperty('--bg-color', '#1d1d1d');
        starClass.style.setProperty('--bg-textColor', '#fff');
        starClass.style.setProperty('--block-color', '#333331');
        quatationClass?.style.setProperty('--quatation-color', '#4a4a4a');
        quatationClass?.style.setProperty('--quatation-textColor', '#fff');
        quatationClass?.style.setProperty('--qua-bg', "#262626");
        modelClass.style.setProperty('--block-color', '#333331');
        dropdownMenuClass.style.setProperty('--block-color', '#333331');
        dropdownMenuClass.style.setProperty('--bg-textColor', '#fff');
        yearClass.style.setProperty('--block-color', '#94a3b8');
        holidaySubClass.style.setProperty('--block-color', '#94a3b8');
        currentDate.style.setProperty('--theme-color', '#ffdd39');
        addScheduleIconBg.style.setProperty('--addSchedule-addBgColor', '#333331')
        Array.from(document.getElementsByClassName('days')).forEach(function (element) {
            element.style.setProperty('--bg-textColor', '#fff');
        });
        Array.from(document.getElementsByClassName('weekend')).forEach(function (element) {
            element.style.setProperty('--weekend-color', '#ffdd50');
        });
        Array.from(document.getElementsByClassName('selected')).forEach(function (element) {
            element.style.setProperty('--block-color', '#4a4a4a');
        });
        Array.from(liElements).forEach(function (element) {
            element.style.setProperty('--theme-color', '#ffdd39');
            element.style.setProperty('--block-color', '#333331');
        });
        Array.from(buttonElements).forEach(function (element) {
            element.style.setProperty('--bg-textColor', '#fff');
            element.style.setProperty('--block-color', '#4a4a4a');
        });
        Array.from(document.querySelectorAll('button.active')).forEach(function (element) {
            element.style.setProperty('--theme-color', '#ffdd39');
        });
        Array.from(document.getElementsByClassName('today')).forEach(function (element) {
            element.style.setProperty('--theme-color', '#ffdd39');
            element.style.setProperty('--block-color', '#333331');
            element.style.setProperty('--theme-bg', '#ffdb39');
        });
        Array.from(document.getElementsByClassName('holidayDate')).forEach(function (element) {
            if (element.classList.contains('today')) {
                element.style.setProperty('--themeDot-color', '#fff');
            } else {
                element.style.setProperty('--themeDot-color', '#ffdb39');
            }
        });
        //no schedule
        noScheduleBg?.style.setProperty("--noSchedule-bgColor", "#4A4A4A30")
        noScheduleIconBg?.style.setProperty("--noSchedule-iconBgColor", "#FDDC0212")
        noScheduleIconColor?.style.setProperty("--noSchedule-iconColor", "#FDDC02")
        scheduleAddIcon?.style.setProperty("--noSchedule-iconColor", "#FDDC02")
        scheduleAddBg?.style.setProperty("--schedule-addBg", "#1C1C1B")
        scheduleAddBgTitle?.style.setProperty("--schedule-addBgTitle", "#FDDC02")
        scheduleSuccessIcon?.style.setProperty("--noSchedule-iconColor", "#FDDC02")
        noScheduleDescColor?.style.setProperty("--noSchedule-descColor", "#fff")
        scheduledelIcon?.style.setProperty("--schedule-delColor", "#FDDC02")
        scheduledelIcon?.style.setProperty("--schedule-delBg", "#29271E")
        scheduleAddOpera?.style.setProperty("--schedule-addBg", "#1C1C1B")
        //schedule
        Array.from(document.querySelectorAll('.scheduleItem .wrap'))?.forEach(function (element) {
            let flag = element.getAttribute("data-flag")
            element.style.setProperty('--schedule-itemBgColor', flag == 'progress' ? '#FDDC02' : flag == 'noStart' ? "#333331" : '#242424');
            element.style.setProperty('--schedule-itemBorderColor', flag == 'progress' ? '#FFEE83' : flag == 'noStart' ? "#333331" : '#242424');
        });
        Array.from(document.querySelectorAll('.scheduleItem .wrap .text')).forEach(function (element) {
            let flag = element.getAttribute("data-flag")
            element.style.setProperty('--schedule-itemTitleColor', flag == 'progress' ? '#000' : flag == 'noStart' ? '#fff' : '#6a6a6a');
        });
        Array.from(document.querySelectorAll('.scheduleItem .wrap .icon'))?.forEach(function (element) {
            let flag = element.getAttribute("data-flag")
            element.style.setProperty('--schedule-ItemIconBg', flag == 'progress' ? '#1D1D1D17' : flag == 'noStart' ? '#CDCDCD1A' : '#2a2a29');
        });
        Array.from(document.querySelectorAll('.scheduleItem .wrap .icon .img'))?.forEach(function (element) {
            let flag = element.getAttribute("data-flag")
            element.style.setProperty('--schedule-ItemIcon', flag == 'progress' ? `url(${getAssetsFile('blackSchedule.png')})` : flag == 'noStart' ? `url(${getAssetsFile('whiteSchedule.png')})` : `url(${getAssetsFile('greySchedule.png')})`);
        });
        Array.from(document.querySelectorAll('.scheduleItem .wrap .text .flag'))?.forEach(function (element) {
            let flag = element.getAttribute("data-flag")
            element.style.setProperty('--schedule-ItemStatusColor', flag == 'progress' ? `#ED3726` : flag == 'noStart' ? `#FDDC02` : `#FFFFFF80`);
        });
        Array.from(document.querySelectorAll('.van-field__body'))?.forEach(function (element) {
            element.style.setProperty('--schedule-addBgCellValBg', '#4A4A4A');
        });
        Array.from(document.querySelectorAll('.van-cell__value'))?.forEach(function (element) {
            element.style.setProperty('--schedule-addBgCellValColor', '#fff');
        });
        Array.from(document.querySelectorAll('.van-cell'))?.forEach(function (element) {
            element.style.setProperty('--schedule-addBgCellBg', '#1C1C1B');
        });
        Array.from(document.querySelectorAll('.van-field__control'))?.forEach(function (element) {
            element.style.setProperty('--schedule-addBgCellValColor', '#fff');
        });
        Array.from(document.querySelectorAll('.van-picker-column__item'))?.forEach(function (element) {
            element.style.setProperty('--schedule-addpickItemColor', '#fff');
        });

    } else if (color == 'orange') {
        hearderClass.style.setProperty('--block-color', '#f7f7f7');
        containerClass.style.setProperty('--bg-color', '#fff');
        containerClass.style.setProperty('--bg-textColor', '#1E293B');
        todayClickClass.style.setProperty('--theme-color', '#FFA5A526');
        todayClickClass.style.setProperty('--bg-color', '#ED3726');
        starClass.style.setProperty('--bg-textColor', '#ED3726');
        starClass.style.setProperty('--block-color', '#f9f9f9');
        quatationClass?.style.setProperty('--quatation-color', '#f9f9f9');
        quatationClass?.style.setProperty('--quatation-textColor', '#1D1D1D');
        quatationClass?.style.setProperty('--qua-bg', `#f3f3f3`);
        modelClass.style.setProperty('--block-color', '#fff');
        dropdownMenuClass.style.setProperty('--block-color', '#fff');
        dropdownMenuClass.style.setProperty('--bg-textColor', '#1d1d1d');
        yearClass.style.setProperty('--block-color', '#575a61');
        holidaySubClass.style.setProperty('--block-color', '#575a61');
        currentDate.style.setProperty('--theme-color', '#ED3726');
        Array.from(document.getElementsByClassName('days')).forEach(function (element) {
            element.style.setProperty('--bg-textColor', '#ED3726');
        });
        Array.from(document.getElementsByClassName('weekend')).forEach(function (element) {
            element.style.setProperty('--weekend-color', '#f73531');
        });
        Array.from(document.getElementsByClassName('selected')).forEach(function (element) {
            element.style.setProperty('--block-color', '#f0f0f0');
        });
        Array.from(liElements).forEach(function (element) {
            element.style.setProperty('--theme-color', '#ED3726');
            element.style.setProperty('--block-color', '#f9f9f9');
        });
        Array.from(buttonElements).forEach(function (element) {
            element.style.setProperty('--bg-textColor', '#1d1d1d');
            element.style.setProperty('--block-color', '#fff');
        });
        // model-dreopDown
        Array.from(document.querySelectorAll('button.active')).forEach(function (element) {
            element.style.setProperty('--theme-color', '#ED3726');
        });
        Array.from(document.getElementsByClassName('today')).forEach(function (element) {
            element.style.setProperty('--theme-color', '#FFA5A526');
            element.style.setProperty('--block-color', '#ED3726');
            element.style.setProperty('--theme-bg', '#FFA5A526');
            // element.style.setProperty('--themeDot-color', '#de496e');
        });
        Array.from(document.getElementsByClassName('holidayDate')).forEach(function (element) {
            element.style.setProperty('--themeDot-color', '#de496e');
        });
        //no schedule
        noScheduleBg?.style.setProperty("--noSchedule-bgColor", "#F3F3F3")
        noScheduleIconBg?.style.setProperty("--noSchedule-iconBgColor", "#F8EBEB")
        noScheduleIconColor?.style.setProperty("--noSchedule-iconColor", "#ED3726")
        noScheduleDescColor?.style.setProperty("--noSchedule-descColor", "#575A61")
        addScheduleIconBg.style.setProperty('--addSchedule-addBgColor', '#f3f3f3')
        scheduleAddIcon?.style.setProperty("--noSchedule-iconColor", "#ED3726")
        scheduleAddBg?.style.setProperty("--schedule-addBg", "#fff")
        scheduleAddBgTitle?.style.setProperty("--schedule-addBgTitle", "#1E293B")
        scheduleSuccessIcon?.style.setProperty("--noSchedule-iconColor", "#ED3726")
        scheduledelIcon?.style.setProperty("--schedule-delColor", "#ED3726")
        scheduledelIcon?.style.setProperty("--schedule-delBg", "#FFEEEE")
        scheduleAddOpera?.style.setProperty("--schedule-addBg", "#fff")

        //schedule
        Array.from(document.querySelectorAll('.scheduleItem .wrap'))?.forEach(function (element) {
            let flag = element.getAttribute("data-flag")
            element.style.setProperty('--schedule-itemBgColor', flag == 'progress' ? '#ED37260D' : flag == 'noStart' ? "#F3F3F3" : '#f9f9f9');
            element.style.setProperty('--schedule-itemBorderColor', flag == 'progress' ? '#FFEEEE' : flag == 'noStart' ? "#F3F3F3" : '#f9f9f9');
        });
        Array.from(document.querySelectorAll('.scheduleItem .wrap .text'))?.forEach(function (element) {
            let flag = element.getAttribute("data-flag")
            element.style.setProperty('--schedule-itemTitleColor', flag == 'progress' ? '#ED3726' : flag == 'noStart' ? "#000" : "#959597");
        });
        Array.from(document.querySelectorAll('.scheduleItem .wrap .icon'))?.forEach(function (element) {
            let flag = element.getAttribute("data-flag")
            element.style.setProperty('--schedule-ItemIconBg', flag == 'progress' ? '#ED37261A' : flag == 'noStart' ? "#CDCDCD63" : "#f1f1f1");
        });
        Array.from(document.querySelectorAll('.scheduleItem .wrap .icon .img'))?.forEach(function (element) {
            let flag = element.getAttribute("data-flag")
            element.style.setProperty('--schedule-ItemIcon', flag == 'progress' ? `url(${getAssetsFile('orangeSchedule.png')})` : flag == 'noStart' ? `url(${getAssetsFile('blackSchedule.png')})` : `url(${getAssetsFile('greySchedule.png')})`);
        });
        Array.from(document.querySelectorAll('.scheduleItem .wrap .text .flag'))?.forEach(function (element) {
            let flag = element.getAttribute("data-flag")
            element.style.setProperty('--schedule-ItemStatusColor', flag == 'progress' ? `#ED3726` : flag == 'noStart' ? `#ED3726` : `#0000004D`);
        });
        Array.from(document.querySelectorAll('.van-field__body'))?.forEach(function (element) {
            element.style.setProperty('--schedule-addBgCellValBg', '#F3F4F8');
        });
        Array.from(document.querySelectorAll('.van-cell__value'))?.forEach(function (element) {
            element.style.setProperty('--schedule-addBgCellValColor', '#1E293B');
        });
        Array.from(document.querySelectorAll('.van-cell'))?.forEach(function (element) {
            element.style.setProperty('--schedule-addBgCellBg', '#fff');
        });
        Array.from(document.querySelectorAll('.van-field__control'))?.forEach(function (element) {
            element.style.setProperty('--schedule-addBgCellValColor', '#1E293B');
        });
        Array.from(document.querySelectorAll('.van-picker-column__item'))?.forEach(function (element) {
            element.style.setProperty('--schedule-addpickItemColor', '#1E293B');
        });
    } else if (color == 'blue') {
        hearderClass.style.setProperty('--block-color', '#f0f2fa');
        containerClass.style.setProperty('--bg-color', '#fff');
        containerClass.style.setProperty('--bg-textColor', '#1E293B');
        todayClickClass.style.setProperty('--theme-color', '#f9f9f9');
        todayClickClass.style.setProperty('--bg-color', '#428BFF');
        starClass.style.setProperty('--bg-textColor', '#428BFF');
        starClass.style.setProperty('--block-color', '#f9f9f9');
        quatationClass?.style.setProperty('--quatation-color', '#f8f9fc');
        quatationClass?.style.setProperty('--quatation-textColor', '#1D1D1D');
        quatationClass?.style.setProperty('--qua-bg', `#f3f4f8`);
        modelClass.style.setProperty('--block-color', '#fff');
        dropdownMenuClass.style.setProperty('--block-color', '#fff');
        dropdownMenuClass.style.setProperty('--bg-textColor', '#1d1d1d');
        yearClass.style.setProperty('--block-color', '#575a61');
        holidaySubClass.style.setProperty('--block-color', '#575a61');
        currentDate.style.setProperty('--theme-color', '#428BFF');
        Array.from(document.getElementsByClassName('days')).forEach(function (element) {
            element.style.setProperty('--bg-textColor', '#428BFF');
        });
        Array.from(document.getElementsByClassName('weekend')).forEach(function (element) {
            element.style.setProperty('--weekend-color', '#278cfb');
        });
        Array.from(document.getElementsByClassName('selected')).forEach(function (element) {
            element.style.setProperty('--block-color', '#f0f0f0');
        });
        // days
        Array.from(liElements).forEach(function (element) {
            element.style.setProperty('--theme-color', '#428BFF');
            element.style.setProperty('--block-color', '#f0f2fa');
        });
        Array.from(buttonElements).forEach(function (element) {
            element.style.setProperty('--bg-textColor', '#1d1d1d');
            element.style.setProperty('--block-color', '#fff');
        });
        // model-dreopDown
        Array.from(document.querySelectorAll('button.active')).forEach(function (element) {
            element.style.setProperty('--theme-color', '#428BFF');
        });
        Array.from(document.getElementsByClassName('today')).forEach(function (element) {
            element.style.setProperty('--theme-color', '#428BFF');
            element.style.setProperty('--block-color', '#fff');
            element.style.setProperty('--theme-bg', '#428BFF');
            element.style.setProperty('--themeDot-color', '#fff');
        });
        Array.from(document.getElementsByClassName('holidayDate')).forEach(function (element) {
            if (element.classList.contains('today')) {
                element.style.setProperty('--themeDot-color', '#fff');
            } else {
                element.style.setProperty('--themeDot-color', '#268cfa');
            }
        });
        //no schedule
        noScheduleBg?.style.setProperty("--noSchedule-bgColor", "#F3F4F8")
        noScheduleIconBg?.style.setProperty("--noSchedule-iconBgColor", "#E1ECFF")
        noScheduleIconColor?.style.setProperty("--noSchedule-iconColor", "#428BFF")
        noScheduleDescColor?.style.setProperty("--noSchedule-descColor", "#575A61")
        addScheduleIconBg.style.setProperty('--addSchedule-addBgColor', '#f3f4f8')
        scheduleAddIcon?.style.setProperty("--noSchedule-iconColor", "#428BFF")
        scheduleAddBg?.style.setProperty("--schedule-addBg", "#fff")
        scheduleAddBgTitle?.style.setProperty("--schedule-addBgTitle", "#1E293B")
        scheduleSuccessIcon?.style.setProperty("--noSchedule-iconColor", "#428BFF")
        scheduledelIcon?.style.setProperty("--schedule-delColor", "#428BFF")
        scheduledelIcon?.style.setProperty("--schedule-delBg", "#E5EFFF")
        scheduleAddOpera?.style.setProperty("--schedule-addBg", "#fff")
        //schedule
        Array.from(document.querySelectorAll('.scheduleItem .wrap'))?.forEach(function (element) {
            let flag = element.getAttribute("data-flag")
            element.style.setProperty('--schedule-itemBgColor', flag == 'progress' ? '#428BFF' : flag == 'noStart' ? '#F3F4F8' : '#f9f9fb');
            element.style.setProperty('--schedule-itemBorderColor', flag == 'progress' ? '#D5E5FF' : flag == 'noStart' ? '#F3F4F8' : '#f9f9fb');
        });
        Array.from(document.querySelectorAll('.scheduleItem .wrap .text'))?.forEach(function (element) {
            let flag = element.getAttribute("data-flag")
            element.style.setProperty('--schedule-itemTitleColor', flag == 'progress' ? '#fff' : flag == 'noStart' ? "#000" : '#909092');
        });
        Array.from(document.querySelectorAll('.scheduleItem .wrap .icon'))?.forEach(function (element) {
            let flag = element.getAttribute("data-flag")
            element.style.setProperty('--schedule-ItemIconBg', flag == 'progress' ? '#FFFFFF21' : flag == 'noStart' ? '#CDCDCD63' : "#f1f2f3");
        });
        Array.from(document.querySelectorAll('.scheduleItem .wrap .icon .img'))?.forEach(function (element) {
            let flag = element.getAttribute("data-flag")
            element.style.setProperty('--schedule-ItemIcon', flag == 'progress' ? `url(${getAssetsFile('whiteSchedule.png')})` : flag == 'noStart' ? `url(${getAssetsFile('blackSchedule.png')})` : `url(${getAssetsFile('greySchedule.png')})`);
        });
        Array.from(document.querySelectorAll('.scheduleItem .wrap .text .flag'))?.forEach(function (element) {
            let flag = element.getAttribute("data-flag")
            element.style.setProperty('--schedule-ItemStatusColor', flag == 'progress' ? `#FDDC02` : flag == 'noStart' ? `#428BFF` : `#0000004D`);
        });
        Array.from(document.querySelectorAll('.van-field__body'))?.forEach(function (element) {
            element.style.setProperty('--schedule-addBgCellValBg', '#F3F4F8');
        });
        Array.from(document.querySelectorAll('.van-cell__value'))?.forEach(function (element) {
            element.style.setProperty('--schedule-addBgCellValColor', '#1E293B');
        });
        Array.from(document.querySelectorAll('.van-cell'))?.forEach(function (element) {
            element.style.setProperty('--schedule-addBgCellBg', '#fff');
        });
        Array.from(document.querySelectorAll('.van-field__control'))?.forEach(function (element) {
            element.style.setProperty('--schedule-addBgCellValColor', '#1E293B');
        });
        Array.from(document.querySelectorAll('.van-picker-column__item'))?.forEach(function (element) {
            element.style.setProperty('--schedule-addpickItemColor', '#1E293B');
        });
    }
}
const weekendDays = computed(() => {
    const daysInMonth = new Date(selectedYear.value, selectedMonth.value, 0).getDate();

    const weekends = [];
    for (let day = 1; day <= daysInMonth; day++) {
        const dayOfWeek = new Date(selectedYear.value, selectedMonth.value - 1, day).getDay();
        if (dayOfWeek === 0 || dayOfWeek === 6) {
            // 周六或周日
            weekends.push(day);
        }
    }
    return weekends;
});
let weeksRow = ref([]);
let monthName = ref([])

function getWeek(id) {
    let week = "";
    weeksRow.value.forEach((item) => {
        if (id == item.id) {
            week = item.name;
        }
    });
    return week;
}
function getMonth(id) {
    let month = "";
    monthName.value.forEach((item) => {
        if (id == item.id) {
            month = item.name;
        }
    });
    return month;
}
//鸡汤
let quotation = ref("no");
function getQuotation(date, dateList) {
    let quotation = "";
    for (const day in dateList) {
        if (day == date) {
            quotation = dateList[date].content;
        }
    }
    return quotation;
}
// 星座
const star = ref({});
function getZodiac(date) {
    const monthDay = date.slice(5); // 从日期字符串中提取 "MM-DD"
    for (const zodiac of starList) {
        let star = {};
        if (monthDay >= zodiac.start && monthDay <= zodiac.end) {
            star.name = zodiac['name' + langObj.value.lang]
            star.img = zodiac.img
            return star;
        }
    }
}
// 获取当天节日
let currentHoliday = ref("")
function getHolidayCurrent(date) {
    // 所选日期，如果过去了，显示距离今天,
    // const selectedDate = new Date(`${realDate.year}-${date}`);
    const selectedDate = new Date(`${selectedYear.value}-${date}`);
    // 获取当前日期
    const now = new Date();
    // 检查所选日期是否已经过去
    let obj = {}
    if (dayjs(selectedDate).format("YYYY-MM-DD") >= dayjs(now).format("YYYY-MM-DD")) {
        festivalList.value.forEach(item => {
            if (item.date == date) {
                obj = item
            }
        })
    }
    return obj
}
// 距离下一个节日
function isDatePassed(selectedDate) {
    const currentDate = new Date();
    const selected = new Date(selectedDate);

    // 确保所选日期不在未来
    if (selected > currentDate) {
        return false;
    }
    return true;
}
let nearestHolidays = ref([]);
let daySel = ref(""); // 判断距离这天
function getNextHolidayDistance(date, holidays) {
    // 2024 所选日期，如果过去了，显示距离今天,
    const isPass = isDatePassed(dayjs(date).format("YYYY-MM-DD"));
    if (isPass) {
        daySel.value = dayjs().format("YYYY-MM-DD");
    } else {
        daySel.value = dayjs(date).format("YYYY-MM-DD");
    }
    const holidayRealYearDistances = holidays
        .map((holiday) => {
            let obj = {};
            const day = realDate.year + "-" + holiday.date;
            const holidayDate = dayjs(`${realDate.year}-${holiday.date}`);
            const distance = holidayDate.diff(daySel.value, "day");
            obj = {
                holiday,
                day,
                distance: distance > 0 ? distance : Infinity,
                date: day.slice(-2),
                year: day.substring(0, 4),
                month: day.substring(5, 7),
            };
            return obj;
        })
        .sort((a, b) => a.distance - b.distance);
    // 2025
    const holidayRealYearAdd1Distances = holidays
        .map((holiday) => {
            let obj = {};
            const day = realDate.year + 1 + "-" + holiday.date;
            const holidayDate = dayjs(`${realDate.year + 1}-${holiday.date}`);
            const distance = holidayDate.diff(daySel.value, "day");
            obj = {
                holiday,
                day,
                distance: distance > 0 ? distance : Infinity,
                date: day.slice(-2),
                year: day.substring(0, 4),
                month: day.substring(5, 7),
            };
            return obj;
        })
        .sort((a, b) => a.distance - b.distance);
    const holidayDistances = holidayRealYearDistances
        .concat(holidayRealYearAdd1Distances)
        .filter((item) => item.distance > 0 && item.distance != Infinity)
        .sort((a, b) => a.distance - b.distance);

    if (isPass) {
        return holidayDistances.slice(0, 4).map((item) => ({
            nextHoliday: item.holiday.name,
            minDistance: item.distance + Math.abs(dayjs(date).diff(daySel.value, "day")),
            day: item.day,
            date: item.day.slice(-2),
            year: item.day.substring(0, 4),
            month: item.day.substring(5, 7),
        }))
    } else {
        return holidayDistances.slice(0, 4).map((item) => ({
            nextHoliday: item.holiday.name,
            minDistance: item.distance,
            day: item.day,
            date: item.day.slice(-2),
            year: item.day.substring(0, 4),
            month: item.day.substring(5, 7),
        }))
    }
}
let now = ref(new Date());
const selectedYear = ref(now.value.getFullYear());
const selectedMonth = ref(now.value.getMonth() + 1);
const selectedDate = ref(now.value.getDate()); // 当前选中的日期
const selectedWeek = ref(now.value.getDay()); // 当前选中的日期周几
const isShow = ref(true); // 默认为收起状态
const isShowSchedule = ref(true); // 默认为收起状态
const currentWeekDays = ref([]); // 日期所在水平7天
// 获取日期所在水平7天
function getWeekDates(selectedDate) {
    // 将字符串日期转换为 dayjs 对象
    const date = dayjs(selectedDate);
    // 获取所选日期是星期几（0-6），dayjs 中 0 是周日
    const weekday = date.day();
    // const checkedMonth = date.month();
    // 获取所选日期所在周的第一天（周日）和最后一天（周六）
    const startOfWeek = date.subtract(weekday, "day");
    const endOfWeek = startOfWeek.add(6, "day");
    const weekDates = [];
    // 生成所选日期所在周的所有日期
    for (let i = 0; i < 7; i++) {
        const day = startOfWeek.add(i, "day").format("DD");
        const mm = startOfWeek.add(i, "day").format("MM");
        const yy = startOfWeek.add(i, "day").format("YYYY");
        weekDates.push({
            day,
            year: yy,
            month: mm,
        });
    }
    return weekDates;
}

const years = computed(() => {
    const startYear = new Date().getFullYear() - 10; // 假设年份范围为过去100年
    const endYear = new Date().getFullYear() + 10;
    return Array.from({ length: endYear - startYear + 1 }, (_, i) => startYear + i);
});
//  这个月的第一天是周几
const firstDateDay = computed(() => {
    return new Date(selectedYear.value, selectedMonth.value - 1, 1).getDay();
});
//  当前的月份有多少天
let holidayDates = ref([])
const getHolidayDates = () => {
    let year = selectedYear.value
    let month = selectedMonth.value
    const dates = [];
    const start = new Date(year, month - 1, 1);
    const end = new Date(year, month, 0);

    for (let current = new Date(start); current <= end; current.setDate(current.getDate() + 1)) {
        dates.push({
            year: current.getFullYear(),
            month: current.getMonth() + 1,
            date: current.getDate(),
            holidayName: ''
        });
    }
    const holidayRealYearDistances = festivalList.value
        .map((holiday) => {
            let obj = {};
            const day = realDate.year + "-" + holiday.date;
            const holidayDate = dayjs(`${realDate.year}-${holiday.date}`);
            const distance = holidayDate.diff(daySel.value, "day");
            obj = {
                holiday,
                day,
                date: day.slice(-2),
                year: day.substring(0, 4),
                month: day.substring(5, 7),
            };
            return obj;
        })
    // 2025
    const holidayRealYearAdd1Distances = festivalList.value
        .map((holiday) => {
            let obj = {};
            const day = realDate.year + 1 + "-" + holiday.date;
            const holidayDate = dayjs(`${realDate.year + 1}-${holiday.date}`);
            const distance = holidayDate.diff(daySel.value, "day");
            obj = {
                holiday,
                day,
                date: day.slice(-2),
                year: day.substring(0, 4),
                month: day.substring(5, 7),
            };
            return obj;
        })
    const holidayDistances = holidayRealYearDistances
        .concat(holidayRealYearAdd1Distances)

    if (dates.length && holidayDistances.length) {
        holidayDates.value = []
        dates.forEach(item => {
            holidayDistances.forEach(itm => {
                if (item.year == Number(itm.year) && item.month == Number(itm.month) && item.date == Number(itm.date)) {
                    holidayDates.value.push(Number(itm.date))
                }
            })
        })
    }

}
const days = computed(() => {
    return new Date(selectedYear.value, selectedMonth.value, 0).getDate();
});
// 监听选中的年份和月份，当它们变化时更新日历
watch([selectedYear, selectedMonth], () => {
    if (!selectedDate.value) {
        selectedDate.value = now.value.getDate(); // 更新选中的日期为当前月份的日期
    }
    if (selectedDate.value == 31 && new Date(selectedYear.value, selectedMonth.value, 0).getDate() < 31) {
        now.value = new Date(selectedYear.value, selectedMonth.value - 1, new Date(selectedYear.value, selectedMonth.value, 0).getDate());
        selectedDate.value = new Date(selectedYear.value, selectedMonth.value, 0).getDate()
    } else {
        now.value = new Date(selectedYear.value, selectedMonth.value - 1, selectedDate.value);
    }
    let current = getFormatDate();
    selectedWeek.value = dayjs(current).day();
    console.log(now.value, "now.value")
    currentWeekDays.value = getWeekDates(dayjs(now.value).format('YYYY-MM-DD'));
    if (selectedYear.value <= realDate.year + 1 && selectedYear.value >= realDate.year - 1) {
        isShow.value = true
        star.value = getZodiac(dayjs(now.value).format('YYYY-MM-DD'))
        currentHoliday.value = getHolidayCurrent(dayjs(now.value).format('YYYY-MM-DD').slice(5, 10))
        nearestHolidays.value = getNextHolidayDistance(dayjs(now.value).format('YYYY-MM-DD'), festivalList.value)
        quotation.value = getQuotation(dayjs(now.value).format('YYYY-MM-DD'), quotationList.value)
        getHolidayDates()
        scheduleAddTime.value = dayjs(now.value).format('YYYY-MM-DD')
        getScheduleList(paramUUid)
    } else {
        isShow.value = false;
        // 清除节假日标识
        holidayDates.value = []
        star.value = getZodiac(dayjs(now.value).format("YYYY-MM-DD"));
    }
});

// 今天的年月日
const realDate = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    date: new Date().getDate(),
    weekday: new Date().getDay(),
};
// 实时计算当前页面显示的年份
const nowYear = computed(() => {
    return now.value.getFullYear();
});
// 实时计算当前页面显示的周几
const nowWeek = computed(() => {
    return now.value.getDay();
});
// 实时计算当前页面显示的月份
const nowMonth = computed(() => {
    return now.value.getMonth() + 1;
});

const itemClick = (item, month = "", yy = "") => {
    selectedDate.value = item; // 更新选中的日期
    let current = null;
    if (month && yy) {
        selectedMonth.value = month;
        selected.value = getMonth(month);
        selectedYear.value = yy;
        current = dayjs(yy + "-" + month + "-" + item).format("YYYY-MM-DD");
    } else {
        current = dayjs(now.value.getFullYear() + "-" + (now.value.getMonth() + 1) + "-" + item).format("YYYY-MM-DD");
    }
    selectedWeek.value = dayjs(current).day();
    currentWeekDays.value = getWeekDates(current);
    star.value = getZodiac(current)
    currentHoliday.value = getHolidayCurrent(current.slice(5, 10))
    nearestHolidays.value = getNextHolidayDistance(current, festivalList.value)
    quotation.value = getQuotation(current, quotationList.value)
    // 日程
    scheduleAddTime.value = current
    getScheduleList(paramUUid)
    nextTick(() => {
        setColor(customColor.value)
    })
    console.log(current, "selectedDate.value", selectedDate.value);
};

// 回到今天
const toToday = () => {
    now.value = new Date();
    currentWeekDays.value = getWeekDates(dayjs().format('YYYY-MM-DD'));
    selectedYear.value = now.value.getFullYear()
    selectedMonth.value = now.value.getMonth() + 1
    selectedWeek.value = now.value.getDay()
    selectedDate.value = now.value.getDate()
    selected.value = getMonth(now.value.getMonth() + 1)
    selectedYear.value = now.value.getFullYear()
    scheduleAddTime.value = dayjs(now.value).format("YYYY-MM-DD");
    let current = dayjs(now.value).format("YYYY-MM-DD")
    getScheduleList(paramUUid)
    selectedWeek.value = dayjs(current).day();
    currentWeekDays.value = getWeekDates(current);
    star.value = getZodiac(current)
    currentHoliday.value = getHolidayCurrent(current.slice(5, 10))
    nearestHolidays.value = getNextHolidayDistance(current, festivalList.value)
    quotation.value = getQuotation(current, quotationList.value)
    getHolidayDates()
    nextTick(() => {
        setColor(customColor.value)
    })
};
</script>

<style>
.van-cell__title {
    width: 120px
}

.addBgOpera {
    display: flex;
    justify-content: space-between;
    align-items: center;
    /* position: fixed; */
    z-index: 9999;
    width: 100%;
    border-top-left-radius: 10px;
    /* 左上角 */
    border-top-right-radius: 10px;
    /* 右上角 */
    background: var(--schedule-addBg)
}

.delSchedule {
    color: var(--schedule-delColor);
    background: var(--schedule-delBg);
    width: 100%;
    margin: 0px 16px;
    font-size: 16px;
    border: none;
    border-radius: 8px;
}

.textareavant {
    display: block !important;
}

.van-cell {
    padding: 0px !important;
    background: var(--schedule-addBgCellBg);

}

.cellFiled {
    padding: 14px 16px !important;
}

.van-cell__title {
    color: #6E6E6E;
    padding-bottom: 4px;
}

.van-cell__value {
    color: var(--schedule-addBgCellValColor)
}

.addBg {

    background: var(--schedule-addBg)
}

.addBgTitle {
    /* margin-top:54px; */
    color: var(--schedule-addBgTitle)
}

.van-field__control {
    padding: 8px;
    height: 48px !important;
    color: var(--schedule-addBgCellValColor)
}

.van-field__body {
    background: var(--schedule-addBgCellValBg);
    border-radius: 8px;
}

.van-picker__mask {
    background: var(--schedule-addpickColumns) !important
}

.van-picker-column__item {
    color: var(--schedule-addpickItemColor)
}

.van-popup--bottom {
    border-top-left-radius: 10px;
    /* 左上角 */
    border-top-right-radius: 10px;
    /* 右上角 */
}

.van-picker-column__item--selected {
    font-size: 20px;
}

.successIcon {
    color: var(--noSchedule-iconColor)
}

:root:root {
    --van-floating-bubble-size: 36px;
    --van-floating-bubble-icon-size: 20px;
    /* --van-picker-mask-color:none; */
    --van-picker-background-color: none;
    --van-cell-active-color: none;
    --van-cell-border-color: none;
    --van-cell-group-background-color: none;
    --van-picker-action-font-size: 26px;
    --van-field-text-area-min-height: 30px
}

:root {
    --bg-color: #fff --bg-textColor:#1d1d1d --theme-color:#D73122 --theme-bg:#f9ebeb --icon-color:#D73122 --block-color:#f7f7f7 --quatation-color:#f9f9f9;
    --themeDot-color: #D73122 --qua-bg:#f3f4f8 --quatation-textColor:#D73122;
    --noSchedule-bgColor: #F3F4F8 --noSchedule-iconBgColor:#E1ECFF --noSchedule-iconColor:#428BFF --addSchedule-addBgColor --schedule-itemIcon: --schedule-itemBgColor:#F3F4F8 --schedule-itemBorderColor:#fff --schedule-itemTitleColor:#212525 --schedule-ItemIcon:url("/img/blackSchedule.png") --schedule-ItemIconBg:#FFFFFF21 --schedule-ItemStatusColor:#fff --schedule-addBg:#fff --schedule-addBgTitle:#1E293B --schedule-addBgCellBg:#1E293B --schedule-addBgCellValBg:#1E293B --schedule-addBgCellValColor:#1E293B --schedule-addpickItemColor:#1E293B --schedule-addpickColumns:#1E293B --noSchedule-descColor:#1E293B --schedule-delColor:#1E293B --schedule-delBg:#1E293B --weekend-color:#1E293B
}

.noSchedule {
    background: var(--noSchedule-bgColor);
    border-radius: 10px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.noSchedule .wrap {
    background: var(--noSchedule-iconBgColor);
    /* padding: 6px 30px;  */
    width: 82px;
    height: 34px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    margin-top: 18px
}

.noSchedule .wrap .plusIcon {
    color: var(--noSchedule-iconColor);
    font-size: 22px;
    margin-top: 5px
}

.noSchedule .desc {
    margin: 10px;
    font-size: 14px;
    color: var(--noSchedule-descColor);
}

.addSchedule .addWrap {
    background: var(--addSchedule-addBgColor);
    /* padding: 6px 30px;  */
    width: 48px;
    height: 34px;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 18px
}

.scheduleItem {
    border-radius: 5px;
    margin-bottom: 8px
}

.scheduleItem .wrap {
    display: flex;
    justify-content: space-between;
    background: var(--schedule-itemBgColor);
    border: 4px solid var(--schedule-itemBorderColor);
    border-radius: 10px;
    padding: 15px 10px
}

.scheduleItem .wrap .icon {
    width: 42px;
    height: 38px;
    background: var(--schedule-ItemIconBg);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    margin-right: 4px
}

.scheduleItem .wrap .icon .img {
    width: 20px;
    height: 20px;
    background-image: var(--schedule-ItemIcon);
    background-repeat: no-repeat;
    background-size: contain
}

.scheduleItem .wrap .text {
    width: 85%;
    color: var(--schedule-itemTitleColor);
    padding-left: 8px;
    font-weight: 600
}

.scheduleItem .wrap .text .title {
    font-size: 14px;
    margin-bottom: 4px;
    /* white-space: nowrap; 
    overflow: hidden;
    text-overflow: ellipsis;  */
    display: -webkit-box;
    -webkit-box-orient: vertical;
    /* 设置盒模型方向为垂直 */
    -webkit-line-clamp: 2;
    /* 限制显示两行 */
    overflow: hidden;
    /* 隐藏多余内容 */
}

.scheduleItem .wrap .text .time {
    font-size: 12px;
    display: flex;
    justify-content: space-between;
}

.scheduleItem .wrap .text .time .flag {
    color: var(--schedule-ItemStatusColor)
}

.scheduleItem .wrap .text .time .flag .dot {
    width: 6px;
    /* 圆点的宽度 */
    height: 6px;
    /* 圆点的高度 */
    background-color: var(--schedule-ItemStatusColor);
    border-radius: 50%;
    /* 将元素变为圆形 */
    display: inline-block;
    /* 使圆点可以与其他元素在同一行显示 */
    margin-right: 3px;
}

.scheduleItem .wrap .text .endStyle {
    text-decoration: line-through
}

.weekend {
    /* color: #ff3b30; */
    color: var(--weekend-color)
}

.dropdown {
    position: relative;
}

.confirm {
    background-color: var(--theme-color);
    color: var(--block-color)
}

.dropdown-button {
    border: 1px solid #ccc;
    padding: 10px;
    /* cursor: pointer; */
    border: none;
    outline: none;
    width: 65%;
    font-size: 18px;
    font-weight: bolder;
    background-color: var(--block-color);
    color: var(--bg-textColor);
    text-align: right;
}

.dropdown-menu {
    position: absolute;
    top: 80%;
    left: 0;
    background-color: var(--block-color);
    /* background-color: #fff; */

    /* border: 1px solid #ccc; */
    border-top: none;
    max-height: 250px;
    overflow-y: auto;
    z-index: 9999;
    width: 80%;
    border-radius: 10px;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.1), 1px 0px 2px rgba(0, 0, 0, 0.1), -1px 3px 10px rgba(0, 0, 0, 0.1);
}

.dropdown-menu button {
    background-color: var(--block-color);
    color: var(--bg-textColor);
    white-space: nowrap;
    padding: 10px;
    /* cursor: pointer; */
    width: 100%;
    border: none;
    z-index: 99999999;
    font-size: 16px;
}

.dropdown-menu button.active {
    white-space: nowrap;
    padding: 10px;
    /* cursor: pointer; */
    width: 100%;
    border: none;
    z-index: 99999999;
    font-size: 16px;
    /* background-color:var(--block-color); */
    color: var(--theme-color);
}

.dropdown-menu button:active {
    white-space: nowrap;
    padding: 10px;
    /* cursor: pointer; */
    width: 100%;
    border: none;
    background: #de496e;
    color: #fff;
    z-index: 99999999;
}

/* 隐藏滚动条 */
::-webkit-scrollbar {
    display: none;
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.model {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 100;
    background: rgba(255, 255, 255, 1);
    /* display: flex;
    justify-content: start;
    align-items: center;
    flex-direction: column; */
}

.props {
    padding: 10px 20px 20px;
}

.props .day {
    font-size: 42px;
    line-height: 42px;
    margin-right: 10px;
    font-weight: bolder;
    color: var(--theme-color)
}

.props .year {
    color: var(--block-color);
}

.props .quotation {
    max-height: 150px;
    /* border-radius: 15px; */
    /* padding: 15px 20px; */
    font-size: 14px;

    position: relative;
    /* z-index: 10; */
}

.props .quotation:before {
    content: " ";
    max-height: 150px;
    border-radius: 10px;
    /* padding: 15px 20px; */
    font-size: 14px;
    color: var(--quatation-textColor);
    background-color: var(--quatation-color);
    /* background-image: url("/img/bgLine.png"); */
    background-repeat: no-repeat;
    background-size: cover;
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 8;
}

.props .quotation .bg {
    max-height: 150px;
    position: inherit;
    z-index: 10;
    margin: 0px 20px;
    padding-bottom: 20px;

}

.props .quotation:after {
    content: " ";
    position: absolute;
    top: 10px;
    width: 96%;
    left: 50%;
    transform: translateX(-50%);
    background-color: var(--qua-bg);
    background-repeat: no-repeat;
    /* background-size: cover; */
    height: 100%;
    border-radius: 10px;
    z-index: 0;
}

.props .star {
    /* color: #7360f0;
    background: #ededed; */
    color: var(--bg-textColor);
    background: var(--block-color);
    line-height: 35px;
    padding: 1px 14px;
    margin-bottom: 10px;
    border-radius: 8px;
}

.props .holiday .item {
    display: flex;
    justify-content: space-between;
    /* background: #ededed; */
    padding: 15px;
    margin-bottom: 10px;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
}

ul>li {
    border-left: 3px solid var(--theme-color);
    background: var(--block-color);
}

/* ul > li:nth-child(1) {
    border-left: 3px solid #c44efb;
}
ul > li:nth-child(2) {
    border-left: 3px solid #4ad2c9;
}
ul > li:nth-child(3) {
    border-left: 3px solid #536eff;
}
ul > li:nth-child(4) {
    border-left: 3px solid #ffc374;
}
ul > li:nth-child(5) {
    border-left: 3px solid #de496e;
} */
.props .holiday .item .days {
    color: var(--bg-textColor);
}

.props .holiday .holidaySub {
    color: var(--block-color)
}

.container .calendar .item.selected {
    background-color: var(--block-color);
}

.select select {
    margin: 5px;
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.select select option {
    font-size: 12px;
}

.container .header {
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 20px 0px;
    background-color: var(--block-color);
    /* background-image: url("/img/bg.png");
    background-repeat: no-repeat;
    background-size: cover; */
}

.container .header .name {
    font-size: 26px;
    font-weight: bolder;
}

.container .header .headerRight {
    display: flex;
    justify-content: space-around;
    align-content: center;
}

.container .addSchedule {
    margin-left: 20px;
    font-size: 22px;
}

.container .addSchedule .icon {
    color: var(--noSchedule-iconColor)
}

.container .header .todayClick {
    font-size: 14px;
    color: var(--bg-color);
    padding: 6px 10px;
    border-radius: 6px;
    background: var(--theme-color);
    font-weight: 600;
}

.container .header .title {
    font-size: 26px;
    font-weight: 600;
}

.container .header .btns button {
    height: 26px;
    border-radius: 0;
    margin: 0 2px;
    /* cursor: pointer; */
    border-width: 1px;
}

.container .calendar {
    background: var(--bg-color);
    display: flex;
    flex-wrap: wrap;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    padding: 20px 10px 0px;
    margin-top: -10px;
}

.container .calendar .item {
    width: calc(94% / 7);
    height: 40px;
    text-align: center;
    font-weight: bolder;
    /* cursor: pointer; */
    padding-top: 15px;
    font-size: 18px;
    /* border-top-left-radius: 10px;
    border-top-right-radius: 10px; */
    border-radius: 10px;
    position: relative;
    margin-right: 2px;
    margin: 2px
}

.container .calendar .itemWeek {
    width: calc(94% / 7);
    height: 22px;
    text-align: center;
    font-size: 14px;
    color: #94a3b8;
    /* cursor: pointer; */
    /* padding-bottom: 15px; */
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    margin: 2px
}

.container .calendar .today::after {
    content: "";
    position: absolute;
    top: 80%;
    left: 48%;
    width: 4px;
    height: 4px;
    background-color: var(--themeDot-color);
    border-radius: 50%;
    transform: translate(-50%, -50%);
}

.container .calendar .today {
    font-weight: 600;
    /* color: #de496e !important;
    background: #fff0f0 !important; */
    background: var(--theme-color) !important;
    color: var(--block-color) !important;
}

.container .calendar .todayWeek {
    font-weight: 600;
    /* color: #de496e;
    background: #fff0f0; */
    background: var(--theme-bg) !important;
    color: var(--theme-color) !important;
}

.container .calendarMonth {
    /* width: 84%; */
    background: var(--block-color);
    display: flex;
    flex-wrap: wrap;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    margin-top: -10px;
    padding: 8px 20px 15px;
}

.container .calendarMonth .item {
    width: calc(100%/7);
    height: 11.43vw;
    line-height: 11.43vw;
    text-align: center;
    font-size: 18px;
    position: relative;
    /* margin:1.5px */
}

.container .calendarMonth .itemWeek {
    width: calc(100%/7);
    height: 40px;
    text-align: center;
    /* cursor: pointer; */
    padding-top: 15px;
    font-size: 18px;
    /* border-top-left-radius: 10px;
    border-top-right-radius: 10px; */
    border-radius: 10px;
    position: relative;
    color: #94a3b8;
}

.container .calendarMonth .today {
    font-weight: 600;
    background: var(--theme-bg) !important;
    color: var(--block-color) !important;
    border-radius: 10px;
    width: 96%;
    height: 96%;
    margin: 1.5px;
}

.container .calendarMonth .holidayDate::after {
    content: "";
    position: absolute;
    top: 80%;
    left: 50%;
    width: 4px;
    height: 4px;
    background-color: var(--themeDot-color);
    border-radius: 50%;
    transform: translate(-50%, -50%);
}

/* .container .calendarMonth .today::after {
    content: "";
    position: absolute;
    top: 80%;
    left: 48%;
    width: 4px;
    height: 4px;
    background-color: var(--themeDot-color);
    border-radius: 50%;
    transform: translate(-50%, -50%);
} */
.container .calendarMonth .selected {
    background-color: var(--block-color);
    border-radius: 10px;
    width: 98%;
    height: 98%
        /* margin: 1.5px; */
}

.container {
    width: 100%;
    min-height: 1000px;
    background: var(--bg-color);
    color: var(--bg-textColor)
}

.down-arrow {
    text-align: center;
    margin-left: -20px;
    color: #ededed;
    font-size: 16px;
}

.down-arrow img {
    height: 10px;
    width: 16px;
}

.down-arrow2 {
    display: inline-block;
    position: relative;
}

.down-arrow2::after {
    content: "";
    display: block;
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 10px solid #d9d9d9;
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translateX(-50%);
}

/* 仅针对移动端设备 */
@media screen and (max-width: 768px) {
    select option {
        font-size: 18px !important;
        /* 移动端字体大小 */
    }
}
</style>
